module.exports = __webpack_public_path__ + "img/Photo_10___Construction_2017_36_1.5449df58.jpg";